import { render, staticRenderFns } from "./stageIntro.vue?vue&type=template&id=99aa05ac&scoped=true&"
import script from "./stageIntro.vue?vue&type=script&lang=js&"
export * from "./stageIntro.vue?vue&type=script&lang=js&"
import style0 from "./stageIntro.vue?vue&type=style&index=0&id=99aa05ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99aa05ac",
  null
  
)

export default component.exports